<template>
  <div class="location-model-edit-form flex flex-col">
    <div class="primary-lighten-1 flex w-full flex-col gap-y-2 rounded-md p-2">
      <label>
        <span class="sr-only block text-sm">Locatienaam</span>
        <InputText
          v-model="location.name"
          placeholder="Locatienaam"
          ref="inputName"
          @blur="v$.name.$touch()"
          :errors="v$.name.$errors"
        />
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { requiredValidator } from "@/helper/validation/validators"
import { useFormConfigurator } from "@/composables/form/form-configurator"
import { Location } from "@/models/location.model"
import type { LocationController } from "@/controllers/model-controllers/location-controller"
import { inject, onMounted, ref } from "vue"
import { formFocusHack } from "@/helper/form-helper"
import InputText from "@/components/inputs/InputText.vue"

const rules = {
  name: { requiredValidator }
}

const controller: LocationController = inject("locationController")!
const { model: location, v$ } = useFormConfigurator<Location>({ controller, rules })

const inputName = ref()
onMounted(() => {
  formFocusHack(inputName, location, "name")
})
</script>

<style scoped></style>
